import React from 'react'
import PropTypes from 'prop-types'
import { ErrorMessage } from 'secondstep-components'
import K8LessonsTable from 'components/K8LessonsTable'
import {
  DrawerContent,
  LessonTableWrapper,
  StyledReportsLoading,
} from './component.styles'

const K8Class = ({
  classDetailsReport,
  classLessonColTooltip,
  classMarkedDoneTooltip,
  classStatusColTooltip,
  fixedTop,
  fixedView,
  hasError,
  HeaderComponent,
  headerProps,
  isFetchingClass,
  statusCode,
}) => {
  if (hasError) {
    return <ErrorMessage statusCode={statusCode} />
  }

  if (!HeaderComponent || !headerProps) {
    console.error(
      'K8Class: HeaderComponent and headerProps are required. Please provide both props.',
      {
        HeaderComponent: HeaderComponent?.name || HeaderComponent,
        headerProps,
      },
    )
    return null
  }

  if (isFetchingClass) {
    return <StyledReportsLoading text={'Loading class...'} />
  }

  return (
    <>
      <HeaderComponent {...headerProps} />
      <DrawerContent fixedTop={fixedTop} fixedView={fixedView}>
        <LessonTableWrapper>
          {classDetailsReport?.lessons?.length > 0 && (
            <K8LessonsTable
              lessons={classDetailsReport.lessons}
              lessonsTooltip={classLessonColTooltip}
              markedDoneTooltip={classMarkedDoneTooltip}
              statusTooltip={classStatusColTooltip}
            />
          )}
        </LessonTableWrapper>
      </DrawerContent>
    </>
  )
}

K8Class.propTypes = {
  HeaderComponent: PropTypes.elementType.isRequired,
  classDetailsReport: PropTypes.object,
  classLessonColTooltip: PropTypes.string,
  classMarkedDoneTooltip: PropTypes.string,
  classStatusColTooltip: PropTypes.string,
  fixedTop: PropTypes.bool,
  fixedView: PropTypes.bool,
  hasError: PropTypes.bool,
  headerProps: PropTypes.object.isRequired,
  isFetchingClass: PropTypes.bool,
  statusCode: PropTypes.number,
}

export default K8Class
